import Vue from "vue";
import Vuetify from "vuetify/lib/framework";

Vue.use(Vuetify);

export default new Vuetify({
  theme: {
    dark: false,
    themes: {
      light: {
        primary: "#034ea2",
        secondary: "#ff7700",
        accent: "#EBE519",
        error: "#b71c1c",
      },
    },
  },
});
